'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializePlaybackTechnology;

var _BindVideoEvents = require('./BindVideoEvents');

var _BindVideoEvents2 = _interopRequireDefault(_BindVideoEvents);

var _Injection = require('./Injection');

var _hudlVideoPlayback = require('hudl-video-playback');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

var _shimLogger = require('./utils/shimLogger');

var _shimLogger2 = _interopRequireDefault(_shimLogger);

var _hudlBase = require('hudl-base');

var _PlayableUtils = require('../PlayableUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initializePlaybackTechnology(config, playables) {
  config.playables = (0, _PlayableUtils.convertPlayablesForPlayback)(playables);

  if (config.logger) {
    config.logger = (0, _shimLogger2.default)(config.logger);
  }

  if (config.playables && config.playables.length) {
    if (config.poster) {
      config.playables[0].poster = config.poster;
      config.poster = undefined;
    }
    if (config.ads) {
      config.playables[0].ads = config.ads;
      config.ads = undefined;
    }
  }

  if (!config.theoLicenseUrl) {
    config.theoLicenseUrl = _hudlBase.data.getNullable('theoLicenseUrl');
  }

  var video = new _hudlVideoPlayback.VideoPlayer(config);
  _store2.default.addPlayerInstance(config.playerId, video);
  (0, _BindVideoEvents2.default)(video, config.playerId);

  // we need to merge in any listeners that were created
  // before the video was ready
  (0, _Injection.mergeListenerMapFromUnreadyQueue)();

  return video;
} /**
   * Copyright 2013-2015, Hudl
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * Initialization of the VideoStore with the provided video
   *
   * @providesModule initializePlaybackTechnology
   */

module.exports = exports['default'];